import { Fragment } from "react"

interface Props {
  text: string
}

export function SimpleFormat({ text }: Props) {
  const paragraphs = text.split(/\n\n+/)
  return (
    <>
      {paragraphs.map((para, i) => {
        const lines = para.split("\n")
        return (
          <p key={i}>
            {lines.map((line, j) => (
              <Fragment key={j}>
                {j > 0 && <br />}
                {line}
              </Fragment>
            ))}
          </p>
        )
      })}
    </>
  )
}
